import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

// Material-UI Core
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Popover from "@material-ui/core/Popover";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import Fab from "@material-ui/core/Fab";
import TextField from "@material-ui/core/TextField";

// Custom Component
import Legend from "../../../Legend/Legend";
import TransmittalRecipientChip from "../../../Chip/RFIRecipientChip";

// Material-UI Icon
import AddIcon from "@material-ui/icons/Add";
// Custom Style
import {
  oceanBlueColor,
  grayColor,
  redColor,
} from "../../../../styles/jss/cmsMainStyle";
import { rfiDetailFormStyle } from "../../../../styles/jss/components/RFI/rfiDetailFormStyle";

// Custom Style (Typography)
const PopoverMemberNameTypography = withStyles({
  root: {
    fontSize: 15,
    fontWeight: 400,
    color: oceanBlueColor[10],
  },
})(Typography);

const PopoverCompanyNameTypography = withStyles({
  root: {
    fontSize: 12,
    fontWeight: 400,
    color: grayColor[5],
  },
})(Typography);

const PopoverInternalMsgTypography = withStyles({
  root: {
    fontSize: 10,
    fontWeight: 400,
    color: redColor[5],
  },
})(Typography);
const useStyles = makeStyles((theme) => rfiDetailFormStyle(theme));

const TransmittalAssignList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    submissionValue,
    setSubmissionValue,
    removeRecipientAction,
    handleRecipientClipClick,
    openPopoverId,
    anchorEl,
    handleRecipientClipClose,
    selectRcptDialogHandleOpen,
    validationErrors,
    validate,
    isNew,
    editable,
  } = props;

  let recipientTemplate = null;

  recipientTemplate = [
    {
      id: "responsible",
      title: "Add Responsible By",
      label: "Responsible By",
      recipientType: "RESPONSIBLE",
      dialogOpenName: "Responsible",
      required: true,
      show: true,
      showInRead: true,
    },
    {
      id: "approve",
      title: "Add Approver",
      label: "Approver",
      recipientType: "APPROVE",
      dialogOpenName: "Approver",
      required: true,
      show: true,
      showInRead: true,
    },
    {
      id: "secondapprove",
      title: "Add Second Approver",
      label: "Second Approver",
      recipientType: "SECONDAPPROVER",
      dialogOpenName: "Second Approver",
      required: false,
      show: submissionValue.recipients.APPROVE.length > 0 ? true : false,
      showInRead:
        submissionValue.recipients.SECONDAPPROVER.length > 0 ? true : false,
    },
    {
      id: "thirdapprove",
      title: "Add Third Approver",
      label: "Third Approver",
      recipientType: "THIRDAPPROVER",
      dialogOpenName: "Third Approver",
      required: false,
      show:
        submissionValue.recipients.SECONDAPPROVER.length > 0 &&
        submissionValue.recipients.APPROVE.length > 0
          ? true
          : false,
      showInRead:
        submissionValue.recipients.THIRDAPPROVER.length > 0 ? true : false,
    },
    {
      id: "toexternal",
      title: "To",
      label: "To",
      recipientType: "TOEXTERNAL",
      dialogOpenName: "To",
      required: true,
      show: true,
      showInRead: true,
    },
    {
      id: "cc",
      title: "CC",
      label: "CC",
      recipientType: "CC",
      dialogOpenName: "CC",
      required: false,
      show: true,
      showInRead: true,
    },
  ];

  // Handle Input
  const handleInputChange = (name) => (event) => {
    const data = { ...submissionValue };
    setSubmissionValue({ ...submissionValue, [name]: event.target.value });
    dispatch({
      type: "ADD_RFI_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });
    // if (validateOnChange) {
    //   validate({ ...submissionValue, [name]: event.target.value });
    // }
  };

  const readOnlyAndDisabled = isNew || editable ? false : true;

  return (
    <Fragment>
      <Grid item xs={12}>
        <Box border={1} borderColor={"grey.500"} className={classes.boxArea}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" className={classes.headerText}>
              Assign List
            </Typography>
            <Divider className={classes.divider} />
          </Grid>
          <div className={classes.messageRecipientArea}>
            {(isNew || editable) &&
              recipientTemplate
                .filter((obj) => obj.show === true)
                .map((obj, index) => {
                  return (
                    <div key={index}>
                      <Grid item xs={12}>
                        <Legend
                          id={obj.id}
                          label={obj.label}
                          required={obj.required}
                          normalTitleColor={grayColor[10]}
                          normalBorderColor={grayColor[4]}
                          messageTitleColor={redColor[6]}
                          messageBorderColor={redColor[6]}
                          error={
                            validationErrors[obj.recipientType] &&
                            validationErrors[obj.recipientType] !== ""
                              ? true
                              : false
                          }
                          helperText={validationErrors[obj.recipientType]}
                        >
                          <div className={classes.legendArea}>
                            {submissionValue.recipients[obj.recipientType] &&
                              submissionValue.recipients[obj.recipientType].map(
                                (res, index) => {
                                  return (
                                    <Fragment key={index}>
                                      <TransmittalRecipientChip
                                        key={index}
                                        id={index}
                                        isNew={isNew}
                                        editable={editable}
                                        rcptType={res.rcpt_type}
                                        group_seq={res.group_seq}
                                        recipientType={obj.recipientType}
                                        rcptName={
                                          res.rcpt_type === "USER"
                                            ? res.fullname
                                            : res.rcpt_type === "USERGROUP"
                                            ? res.group_name
                                            : ""
                                        }
                                        is_attachment_readable={
                                          res.is_attachment_readable
                                        }
                                        site_user_seq={res.site_user_seq}
                                        submissionValue={submissionValue}
                                        setSubmissionValue={setSubmissionValue}
                                        removeAction={() =>
                                          removeRecipientAction(
                                            obj.recipientType,
                                            res.rcpt_type === "USERGROUP"
                                              ? res.type_seq
                                              : "",
                                            res
                                          )
                                        }
                                        handleRecipientClipClick={handleRecipientClipClick(
                                          res.group_seq
                                        )}
                                      />
                                    </Fragment>
                                  );
                                }
                              )}
                          </div>
                          <Box className={classes.addFileBtnArea}>
                            <Tooltip title={obj.title}>
                              <Fab
                                color="primary"
                                size="small"
                                aria-label="add_recipient"
                                className={classes.fileUploadBtn}
                                onClick={() => {
                                  selectRcptDialogHandleOpen(
                                    obj.recipientType,
                                    obj.dialogOpenName
                                  );
                                }}
                              >
                                <AddIcon />
                              </Fab>
                            </Tooltip>
                          </Box>
                        </Legend>
                      </Grid>
                    </div>
                  );
                })}
            {!isNew &&
              !editable &&
              recipientTemplate
                .filter((obj) => obj.showInRead === true)
                .map((obj, index) => {
                  return (
                    <div key={index}>
                      <Grid item xs={12}>
                        <Legend
                          id={obj.id}
                          label={obj.label}
                          required={obj.required}
                          normalTitleColor={grayColor[10]}
                          normalBorderColor={grayColor[4]}
                          messageTitleColor={redColor[6]}
                          messageBorderColor={redColor[6]}
                          error={
                            validationErrors[obj.recipientType] &&
                            validationErrors[obj.recipientType] !== ""
                              ? true
                              : false
                          }
                          helperText={validationErrors[obj.recipientType]}
                        >
                          <div className={classes.legendArea}>
                            {submissionValue.recipients[obj.recipientType] &&
                              submissionValue.recipients[obj.recipientType].map(
                                (res, index) => {
                                  return (
                                    <Fragment key={index}>
                                      <TransmittalRecipientChip
                                        key={index}
                                        id={index}
                                        isNew={isNew}
                                        editable={editable}
                                        rcptType={res.rcpt_type}
                                        group_seq={res.group_seq}
                                        recipientType={obj.recipientType}
                                        rcptName={
                                          res.rcpt_type === "USER"
                                            ? res.fullname
                                            : res.rcpt_type == "USERGROUP"
                                            ? res.rcpt_name
                                            : ""
                                        }
                                        is_attachment_readable={
                                          res.is_attachment_readable
                                        }
                                        site_user_seq={res.site_user_seq}
                                        submissionValue={submissionValue}
                                        setSubmissionValue={setSubmissionValue}
                                        removeAction={null}
                                        handleRecipientClipClick={handleRecipientClipClick(
                                          res.group_seq
                                        )}
                                      />
                                      <Popover
                                        id={res.rcpt_seq}
                                        open={openPopoverId === res.group_seq}
                                        anchorEl={anchorEl}
                                        onClose={handleRecipientClipClose}
                                        anchorOrigin={{
                                          vertical: "bottom",
                                          horizontal: 115,
                                        }}
                                        transformOrigin={{
                                          vertical: "top",
                                          horizontal: "center",
                                        }}
                                      >
                                        {res.rcpt_type === "USERGROUP" ? (
                                          <div className={classes.popoverMain}>
                                            {res.group_members.map(
                                              (member, index) => {
                                                return (
                                                  <div key={index}>
                                                    <div
                                                      className={
                                                        classes.popoverMember
                                                      }
                                                    >
                                                      <PopoverMemberNameTypography>
                                                        {member.fullname}
                                                      </PopoverMemberNameTypography>
                                                      <PopoverCompanyNameTypography>
                                                        {member.company_name}
                                                      </PopoverCompanyNameTypography>
                                                    </div>
                                                    <Divider />
                                                  </div>
                                                );
                                              }
                                            )}
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Popover>
                                    </Fragment>
                                  );
                                }
                              )}
                          </div>
                          {submissionValue.recipients[obj.recipientType]
                            .length === 0 && (
                            <div>
                              <br /> <br />
                            </div>
                          )}
                        </Legend>
                      </Grid>
                    </div>
                  );
                })}
            <Grid item xs={12}>
              <TextField
                className={classes.textField}
                fullWidth={true}
                id={"attention"}
                name={"attention"}
                label={"Attention"}
                type="text"
                size="small"
                variant="outlined"
                value={submissionValue.attention || ""}
                onChange={handleInputChange("attention")}
                InputProps={{
                  readOnly: readOnlyAndDisabled,
                  maxLength: 255,
                }}
              ></TextField>
            </Grid>
          </div>
        </Box>
      </Grid>
    </Fragment>
  );
};

export default TransmittalAssignList;
